import { render, staticRenderFns } from "./ConfirmResetPassword.vue?vue&type=template&id=c9d2733a&scoped=true&"
import script from "./ConfirmResetPassword.vue?vue&type=script&lang=js&"
export * from "./ConfirmResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmResetPassword.vue?vue&type=style&index=0&id=c9d2733a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d2733a",
  null
  
)

export default component.exports